import {
  all,
  call,
  fork,
  put,
  takeEvery,
  take,
  select,
} from "redux-saga/effects";
import {
  SIGNIN_USER,
  SIGNOUT_USER,
  SIGNUP_USER,
  CREATE_COGNITO_USER,
  VERIFY_COGNITO_USER,
  SIGN_IN_COGNITO_USER,
  INIT_COGNITO_AUTH_SESSION,
  ACCEPT_OTP,
} from "./../../constants/ActionTypes";
import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
  verifyUserPhoneNumber,
  initCognitoAuthSession,
  signInCognitoUserSuccess,
  verifyCognitoOtp,
  signUpCognitoUserSuccess,
} from "../../appRedux/actions/Auth";

import {
  onUserSignInConfirm,
  signInUserWithCognito,
  signUpUserWithCognito,
  signInCognitoUserwithPhone,
  signInCognitoUserWithOTP,
  signOutUserWithCognito,
  initAppSyncClient,
} from "./../../aws/appsync";
import { VERIFY_COGNITO_OTP } from "../../constants/ActionTypes";
import TeachersOperations from "../../aws/gql/TeachersOperations";
import { signupSuccessful } from "../../analytics";
function* createCognitoUserWithPhone({ payload }) {
  if (!payload) return;
  let { phone,countryCode } = payload || {};
  if(phone[0] === '0'){
    phone = phone.slice(1)
  }
  try {
    const signUpUser = yield call(signUpUserWithCognito, phone,countryCode);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      // localStorage.setItem('user_id', signUpUser.usersub);
      // yield put(acceptOTP());
      yield put(verifyCognitoOtp(signUpUser));
    }
  } catch (error) {
    if (error && error.code === "UsernameExistsException") {
      yield put(
        showAuthMessage(
          "Account with this number already exists. Check your phone number or try logging into your existing account."
        )
      );
    } else {
      yield put(showAuthMessage(error.message || error));
    }
  }
}
function* signInCognitoUserWithPhone({ payload }) {
  let { phone,countryCode } = payload;
  // strip leading 0 from the phone nubmer
  if(phone[0] === '0'){
    phone = phone.slice(1)
  }
  try {
    const signInUser = yield call(signInCognitoUserwithPhone, phone,countryCode);
    if (signInUser.message) {
      yield put(showAuthMessage(signInUser.message));
    } else {
      // localStorage.setItem('user_id', signUpUser.usersub);
      // yield put(putCognitoUser(signUpUser));
      yield put(verifyCognitoOtp(signInUser));
      //
    }
  } catch (error) {
    if (error && error.code === "NotAuthorizedException") {
      return yield put(
        showAuthMessage("User account not found. Try registering again.")
      );
    }
    yield put(showAuthMessage(error.message || error));
  }
}
function* verifyCognitoUserWithPhone({ payload }) {
  const { cognitoUser, otp } = payload;
  if (!cognitoUser || !otp) return;
  try {
    const signUpUser = yield call(
      onUserSignInConfirm,
      cognitoUser.username,
      otp
    );
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.usersub);
      yield put(signUpCognitoUserSuccess(signUpUser));
      // ...
      const {
        first_name,
        last_name,
        phone,
        board,
        grade,
        school_id,
        school_name,
        email
      } = yield select((state) => state.auth.userDetails);
      signupSuccessful({
        first_name,
        last_name,
        phone,
        board,
        grade,
        school_id,
        school_name,
        email
      });
      yield call(
        TeachersOperations.putTeacher,
        school_id,
        [first_name, last_name].join(" "),
        school_name,
        phone,
        board,
        grade,
        email
      );
      // write the user to dynamo
    }
  } catch (error) {
    yield put(showAuthMessage(error.message || error));
  }
}
function* signInCognitoUserWithOtp({ payload }) {
  const { cognitoUser, otp } = payload;
  try {
    const signUpUser = yield call(signInCognitoUserWithOTP, cognitoUser, otp);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem("user_id", signUpUser.usersub);
      yield put(signInCognitoUserSuccess(signUpUser));
    }
  } catch (error) {
    yield put(
      showAuthMessage(
        error ? error.message : error || "OTP verification failed"
      )
    );
  }
}
function* createUserWithEmailPassword({ payload }) {
  const { phone } = payload;

  try {
    const signUpUser = yield call(signUpUserWithCognito, phone);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      // localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(verifyUserPhoneNumber(signUpUser));
    }
  } catch (error) {
    yield put(showAuthMessage(error.message || error));
  }
}




function* signInUserWithEmailPassword({ payload }) {
  const { email } = payload;
  try {
    const signInUser = yield call(signInUserWithCognito, email);
    if (signInUser.message) {
      yield put(showAuthMessage(signInUser.message));
    } else {
      localStorage.setItem("user_id", signInUser.attributes.sub);
      yield put(userSignInSuccess(signInUser.attributes.sub));
    }
  } catch (error) {
    yield put(showAuthMessage(error.message || error));
  }
}

function* signOut() {
  try {
    const signOutUser = yield call(signOutUserWithCognito);
    localStorage.removeItem("user_id");
    yield put(userSignOutSuccess(signOutUser));
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* initAuthSession(authSession) {
  async function __initAuth() {
    const appsyncClient = await initAppSyncClient();
    console.log(appsyncClient);
    if (authSession) {
      initAppSyncClient();
    }
    put(initCognitoAuthSession(authSession));
  }
  yield __initAuth();
}
export function* verifyCognitoUser() {
  yield takeEvery(VERIFY_COGNITO_USER, signInCognitoUserWithOtp);
}
export function* verifyCognitoUserOtp() {
  yield takeEvery(VERIFY_COGNITO_OTP, verifyCognitoUserWithPhone);
}
export function* createCognitoUser() {
  yield takeEvery(CREATE_COGNITO_USER, createCognitoUserWithPhone);
}
export function* signInCognitoUser() {
  yield takeEvery(SIGN_IN_COGNITO_USER, signInCognitoUserWithPhone);
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export function* initCognitoSession() {
  // yield put(initCognitoAuthSession())
  yield take(INIT_COGNITO_AUTH_SESSION, initAuthSession);
}
export function* acceptOtp() {
  // yield put(initCognitoAuthSession())
  yield take(ACCEPT_OTP);
}

export default function* rootSaga() {
  yield all([
    fork(signInUser),
    fork(createUserAccount),
    fork(signOutUser),
    fork(createCognitoUser),
    fork(verifyCognitoUser),
    fork(verifyCognitoUserOtp),
    fork(signInCognitoUser),
    fork(initCognitoSession),
  ]);
}
